import { render, staticRenderFns } from "./editUserDrawer.vue?vue&type=template&id=2c6956f4&scoped=true"
import script from "./editUserDrawer.vue?vue&type=script&lang=js"
export * from "./editUserDrawer.vue?vue&type=script&lang=js"
import style0 from "./editUserDrawer.vue?vue&type=style&index=0&id=2c6956f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6956f4",
  null
  
)

export default component.exports